import { motion } from "framer-motion";
import { API_ENDPOINT } from "../../../../../../lib/api-url";
import { useState, useEffect } from "react";
import axios from "axios";

const CapitanCard = ({ name, avatarUrl }) => {
  return (
    <div className="w-fit ">
      <div className="relative flex justify-center">
        <div className="absolute w-full h-full   flex justify-center items-end">
          <img src={ "/avatar/avatar-default.webp"} className="w-[226px] " />
          {/* <img src={ avatarUrl? `https://backtest.ahangariholding.com/${avatarUrl}` :"/avatar/avatar-default.webp"} className="w-[226px] " /> */}
        </div>
        <img src="/capitan/capitan-container.png" className="w-[327px]" />
      </div>
      <div className="relative w-fit h-fit">
        <div
          className="absolute flex justify-center  items-center w-full h-full text-[24px] font-bold text-white"
          style={{ fontFamily: "Peyda" }}
        >
          {name}
        </div>
        <img className="-mt-10" src="/capitan/capitan-name.svg" />
      </div>
    </div>
  );
};

const CapitanPage = () => {
  const cards = [1, 1, 1, 1];
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setLoading(true);
        const res = await axios.get(API_ENDPOINT.wallTeams.sabziTeams);
        const data = Array.isArray(res?.data?.data) ? res.data.data : [];
        console.log("incoming data for the :", data);
        if (mounted) setRows(data);
      } catch (e) {
        console.error(e);
        if (mounted) setErr("Failed to fetch transfer market.");
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="w-full h-full overflow-hidden flex items-center justify-center">
      <div className="w-full h-screen absolute top-0 left-0">
        <div className="w-full h-full relative flex items-center justify-center">
          <video
            className="w-full h-full top-0 object-cover absolute"
            src="/capitan/bg-capitans.mp4"
            autoPlay
            loop
            muted
            playsInline
          />
          <div
            style={{
              scale: "1.5",
            }}
            className="  gap-20 flex justify-center items-center relative "
          >
            {rows &&
              rows.map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: -50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    delay: (cards.length - 1 - index) * 0.3,
                    duration: 0.6,
                    ease: "easeOut",
                  }}
                >
                  <CapitanCard
                    name={
                      item.captain?.first_name + " " + item.captain?.last_name
                    }
                    key={index}
                  />
                </motion.div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CapitanPage;
